import React from 'react'

import { components } from 'react-select'

import Avatar from '../WorkQueuesContent/components/avatar'

/**
 * Custom option component for react-select
 * @requires an extra prop called `user` to be passed in the option object
 * */
export function OptionWithAvatar(props) {
  return (
    <components.Option {...props}>
      <div className='flex space-x-2 items-center'>
        <Avatar user={props.data?.user ?? {}} />
        <div>{props.children}</div>
      </div>
    </components.Option>
  )
}
